<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PanelListing />

    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PanelListing from "@/views/pages/admin/panel/panelListing";

export default {
    page: {
        title: i18n.t("module.panel"),
    },
    components: { Layout, PageHeader, PanelListing },
    data() {
        return {
            title: i18n.t("module.panel"),
            items: [
                {
                    text: i18n.t("module.vehicle"),
                    href: '/vehicles',
                },
                {
                    text: i18n.t("module.panel"),
                    active: true,
                },
            ],
        };
    },
}
</script>